import server from "../../assets/icons/server.png"
import automation from "../../assets/icons/automation.png"
import design from '../../assets/icons/design.png'
import frontend from "../../assets/icons/frontend.png"


const Skills = [
    {
        icon: frontend,
        title: "Frontend Development",
        about: "Using React.js || NEXT.js || Styled Components || Bootstrap || Material-Ui "
    },
    {
        icon: server,
        title: "Backend  Development",
        about: "I Do Back End With Node.js(Express) ",
    },
    {
        icon: automation,
        title: "Testing Of Web Apps ",
        about: "Unit Testing With Jest And Enzyme || Automation Testing With Cypress "
    },
    {
        icon: design,
        title: "UI/UX designer",
        about: "Minimalistic User Interface Design Using Figma"
    },
   
   
]

export default Skills;

